export interface Match {
  id: string;
  homeTeam: string;
  awayTeam: string;
  homeScore?: number;
  awayScore?: number;
  league: string;
  category: string;
  categorySlug: string;
  time: string;
  status: 'upcoming' | 'live' | 'finished';
  homeOdds?: number;
  drawOdds?: number;
  awayOdds?: number;
}

export const featuredMatches: Match[] = [
  {
    id: 'match-1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 2,
    awayScore: 1,
    league: '西甲联赛',
    category: '足球',
    categorySlug: 'football',
    time: '2026-08-08 22:00',
    status: 'live',
    homeOdds: 2.10,
    drawOdds: 3.50,
    awayOdds: 3.20,
  },
  {
    id: 'match-2',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeScore: 98,
    awayScore: 102,
    league: 'NBA常规赛',
    category: '篮球',
    categorySlug: 'basketball',
    time: '2026-08-08 10:30',
    status: 'live',
    homeOdds: 1.85,
    awayOdds: 1.95,
  },
  {
    id: 'match-3',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    league: '英超联赛',
    category: '足球',
    categorySlug: 'football',
    time: '2026-08-09 03:00',
    status: 'upcoming',
    homeOdds: 1.75,
    drawOdds: 3.80,
    awayOdds: 4.50,
  },
  {
    id: 'match-4',
    homeTeam: 'T1',
    awayTeam: 'Gen.G',
    league: 'LCK夏季赛',
    category: '电竞',
    categorySlug: 'esports',
    time: '2026-08-08 16:00',
    status: 'upcoming',
    homeOdds: 1.90,
    awayOdds: 1.90,
  },
  {
    id: 'match-5',
    homeTeam: 'AC米兰',
    awayTeam: '尤文图斯',
    homeScore: 0,
    awayScore: 0,
    league: '意甲联赛',
    category: '足球',
    categorySlug: 'football',
    time: '2026-08-08 02:45',
    status: 'live',
    homeOdds: 2.80,
    drawOdds: 3.10,
    awayOdds: 2.50,
  },
  {
    id: 'match-6',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    league: 'ATP大师赛',
    category: '网球',
    categorySlug: 'tennis',
    time: '2026-08-09 20:00',
    status: 'upcoming',
    homeOdds: 2.20,
    awayOdds: 1.70,
  },
];

export const matchesByCategory: Record<string, Match[]> = {
  football: [
    {
      id: 'fm-1',
      homeTeam: '皇家马德里',
      awayTeam: '巴塞罗那',
      homeScore: 2,
      awayScore: 1,
      league: '西甲联赛',
      category: '足球',
      categorySlug: 'football',
      time: '2026-08-08 22:00',
      status: 'live',
    },
    {
      id: 'fm-2',
      homeTeam: '曼城',
      awayTeam: '阿森纳',
      league: '英超联赛',
      category: '足球',
      categorySlug: 'football',
      time: '2026-08-09 03:00',
      status: 'upcoming',
    },
    {
      id: 'fm-3',
      homeTeam: 'AC米兰',
      awayTeam: '尤文图斯',
      league: '意甲联赛',
      category: '足球',
      categorySlug: 'football',
      time: '2026-08-08 02:45',
      status: 'live',
    },
    {
      id: 'fm-4',
      homeTeam: '拜仁慕尼黑',
      awayTeam: '多特蒙德',
      league: '德甲联赛',
      category: '足球',
      categorySlug: 'football',
      time: '2026-08-10 00:30',
      status: 'upcoming',
    },
    {
      id: 'fm-5',
      homeTeam: '巴黎圣日耳曼',
      awayTeam: '马赛',
      league: '法甲联赛',
      category: '足球',
      categorySlug: 'football',
      time: '2026-08-10 03:00',
      status: 'upcoming',
    },
    {
      id: 'fm-6',
      homeTeam: '上海海港',
      awayTeam: '山东泰山',
      league: '中超联赛',
      category: '足球',
      categorySlug: 'football',
      time: '2026-08-09 19:35',
      status: 'upcoming',
    },
  ],
  basketball: [
    {
      id: 'bm-1',
      homeTeam: '洛杉矶湖人',
      awayTeam: '金州勇士',
      homeScore: 98,
      awayScore: 102,
      league: 'NBA常规赛',
      category: '篮球',
      categorySlug: 'basketball',
      time: '2026-08-08 10:30',
      status: 'live',
    },
    {
      id: 'bm-2',
      homeTeam: '波士顿凯尔特人',
      awayTeam: '密尔沃基雄鹿',
      league: 'NBA常规赛',
      category: '篮球',
      categorySlug: 'basketball',
      time: '2026-08-09 08:00',
      status: 'upcoming',
    },
    {
      id: 'bm-3',
      homeTeam: '中国男篮',
      awayTeam: '日本男篮',
      league: 'FIBA世界杯预选赛',
      category: '篮球',
      categorySlug: 'basketball',
      time: '2026-08-10 19:00',
      status: 'upcoming',
    },
  ],
  tennis: [
    {
      id: 'tm-1',
      homeTeam: '德约科维奇',
      awayTeam: '阿尔卡拉斯',
      league: 'ATP大师赛',
      category: '网球',
      categorySlug: 'tennis',
      time: '2026-08-09 20:00',
      status: 'upcoming',
    },
    {
      id: 'tm-2',
      homeTeam: '辛纳',
      awayTeam: '梅德韦杰夫',
      league: 'ATP大师赛',
      category: '网球',
      categorySlug: 'tennis',
      time: '2026-08-08 18:00',
      status: 'live',
    },
    {
      id: 'tm-3',
      homeTeam: '斯瓦泰克',
      awayTeam: '萨巴伦卡',
      league: 'WTA巡回赛',
      category: '网球',
      categorySlug: 'tennis',
      time: '2026-08-10 16:00',
      status: 'upcoming',
    },
  ],
  esports: [
    {
      id: 'em-1',
      homeTeam: 'T1',
      awayTeam: 'Gen.G',
      league: 'LCK夏季赛',
      category: '电竞',
      categorySlug: 'esports',
      time: '2026-08-08 16:00',
      status: 'upcoming',
    },
    {
      id: 'em-2',
      homeTeam: 'JDG',
      awayTeam: 'BLG',
      league: 'LPL夏季赛',
      category: '电竞',
      categorySlug: 'esports',
      time: '2026-08-09 17:00',
      status: 'upcoming',
    },
    {
      id: 'em-3',
      homeTeam: 'FaZe Clan',
      awayTeam: 'NAVI',
      league: 'CS:GO Major',
      category: '电竞',
      categorySlug: 'esports',
      time: '2026-08-08 20:00',
      status: 'live',
    },
  ],
  others: [
    {
      id: 'om-1',
      homeTeam: '马龙',
      awayTeam: '樊振东',
      league: '乒乓球世锦赛',
      category: '综合',
      categorySlug: 'others',
      time: '2026-08-10 14:00',
      status: 'upcoming',
    },
    {
      id: 'om-2',
      homeTeam: '中国女排',
      awayTeam: '巴西女排',
      league: '女排世界联赛',
      category: '综合',
      categorySlug: 'others',
      time: '2026-08-09 15:00',
      status: 'upcoming',
    },
  ],
};